import React from "react";
import { useSelector } from "react-redux";
import { selectCurrentCoopData } from "../../../store/auth";
import { useUser } from "../../../hooks";
import { AuthShell } from "../../Auth";
import ForgetPasswordForm from "./ForgetPasswordForm";

const RESET_POINTS = [
  "We send a 6-digit code to the email or phone on your account.",
  "The code stays valid for 5 minutes.",
];

export default function ForgetPasswordComp({ isCompanyLoading = false }) {
  const coopData = useSelector(selectCurrentCoopData);
  const user = useUser();
  // Prefer the cooperative fetched for this domain, then the signed-in user's company.
  const company = coopData || user?.company;

  return (
    <AuthShell company={company} loading={isCompanyLoading} points={RESET_POINTS}>
      <ForgetPasswordForm />
    </AuthShell>
  );
}
